import { render, staticRenderFns } from "./PeopleUnitInput.vue?vue&type=template&id=f7533ffe&scoped=true"
import script from "./PeopleUnitInput.vue?vue&type=script&lang=js"
export * from "./PeopleUnitInput.vue?vue&type=script&lang=js"
import style0 from "./PeopleUnitInput.vue?vue&type=style&index=0&id=f7533ffe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7533ffe",
  null
  
)

export default component.exports